module.exports = __webpack_public_path__ + "static/media/sherpa.e0c23d7c.png";